import { ResultAPI } from "../api";
import { store } from "../../redux/store";
import { addGameActivity } from "../../redux/dispatchers";

// evaluateResult returns the results by category
export const evaluateResult = async (category, isComplete) => {
  try {
    const caseId = store.getState().gameStates.case.id;
    const { id } = store.getState().authDetails;

    // process diagnosis
    const d = store.getState().gameStates["differential"];
    d.forEach((tmp) => {
      if (!!tmp && !!tmp.result && !!tmp.result.id) {
        addGameActivity("diagnosis", tmp.result.id);
      }
    });
    const p = store.getState().gameStates["provisional"];
    p.forEach((tmp) => {
      if (!!tmp && !!tmp.result && !!tmp.result.id) {
        addGameActivity("diagnosis", tmp.result.id);
      }
    });
    const f = store.getState().gameStates["final"];
    f.forEach((tmp) => {
      if (!!tmp && !!tmp.result && !!tmp.result.id) {
        addGameActivity("diagnosis", tmp.result.id);
      }
    });

    // process management
    const s = store.getState().gameStates["short"];
    s.forEach((tmp) => {
      if (!!tmp && !!tmp.result && !!tmp.result.id) {
        addGameActivity("management", tmp.result.id);
      }
    });
    const l = store.getState().gameStates["long"];
    l.forEach((tmp) => {
      if (!!tmp && !!tmp.result && !!tmp.result.id) {
        addGameActivity("management", tmp.result.id);
      }
    });

    const { activity } = store.getState().gameStates;

    const result = await ResultAPI.evaluate({
      data: {
        caseId,
        activities: activity,
        userId: id,
      },
      isComplete: isComplete,
    });
    if (!!category) return result[category];
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};
